import { ReactElement } from 'react'

import classNames from 'classnames'
import { Formik, ErrorMessage, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { object, string } from 'yup'

import { OrganizationInvitation } from 'types'

import { AuthError, SubmitButton } from '../Shared'
import * as authStyles from '../styles.scss'

interface FormValues {
    invitationId: string
}

interface Props {
    invitation: OrganizationInvitation
    onSubmit: (values: FormValues) => void
}

const JoinOrganizationForm = ({
    invitation,
    onSubmit,
}: Props): ReactElement => {
    const { t } = useTranslation('account')
    return (
        <>
            <div
                className={classNames(
                    authStyles.authFormTitleBlock,
                    authStyles['authFormTitleBlock--joinOrganization']
                )}
            >
                <div className={authStyles.authFormSubtitle}>
                    {t(
                        'account:JoinOrganizationForm.title',
                        'You have been invited by {{inviterEmail}} to join:',
                        { inviterEmail: invitation.inviter.email }
                    )}
                </div>
                <h1>{invitation.organization.name}</h1>
            </div>

            <Formik
                initialValues={{ invitationId: invitation.id }}
                onSubmit={onSubmit}
                validationSchema={object().shape({
                    invitationId: string()
                        .required()
                        .label(
                            t(
                                'account:JoinOrganizationForm.invitation',
                                'Invitation'
                            )
                        ),
                })}
            >
                {() => (
                    <Form>
                        <SubmitButton
                            className={authStyles.authSubmitButtonTight}
                        >
                            {t(
                                'account:JoinOrganizationForm.submitBtnText',
                                'Join Organization'
                            )}
                        </SubmitButton>
                        <ErrorMessage
                            name="invitationId"
                            component="div"
                            className="fg-control-text is-error"
                        />
                    </Form>
                )}
            </Formik>

            <AuthError />
        </>
    )
}
export default JoinOrganizationForm
